import angular from 'angular';
import template from './template.html';
import moment from 'moment';
import './styles.css';

controller.$inject = ['DriversService', '$stateParams', '$state', 'Alerts', '$scope', '$timeout'];

export function controller(DriversService, $stateParams, $state, Alerts, $scope, $timeout) {
    const vm = this;
    let tmpContractedHours = 0;

    vm.addPreference = addPreference;
    vm.deletePreference = deletePreference;
    vm.isValidPreference = isValidPreference;
    
    vm.deleteDriver = deleteDriver;
    vm.validationErrors = [];
    vm.backupDriverChanged = backupDriverChanged;
    vm.back = back;
    vm.deleteLeaveDate = deleteLeaveDate;

    vm.getDays = getDays;
    vm.getStartDateMaxLimit = getStartDateMaxLimit;
    vm.getLeaveDateMinLimit = getLeaveDateMinLimit;
    vm.save = save;
    vm.restoreDeletedDriver = restoreDeletedDriver;

    getDriver();

    function deleteLeaveDate() {
        vm.driver.leaveDate = '';
        $scope.driverForm.$setDirty();
    }

    function getStartDateMaxLimit() {
        if (vm.driver.leaveDate && Date.parse(vm.driver.leaveDate)) {
            let maxDate = new Date(vm.driver.leaveDate);
            maxDate.setDate(maxDate.getDate() - 1);
            return maxDate.toString();
        }
        return '';
    }

    function getLeaveDateMinLimit() {
        let minDate = new Date(vm.driver.startDate);
        minDate.setDate(minDate.getDate() + 1);
        return minDate.toString();
    }

    function save() {
        vm.driver.startDate = new Date(vm.driver.startDate);
        vm.driver.leaveDate = vm.driver.leaveDate && new Date(vm.driver.leaveDate);
        validate();
        if (vm.validationErrors.length > 0) {
            Alerts.show('Invalid Driver', vm.validationErrors[0], 'error');
        } else {
            DriversService.saveDriver(vm.driver).then(() => {
                $scope.driverForm.$setPristine();
                if (vm.driver.id === 0) { //added new driver so go back to list
                    back();
                }
            });
        }
    }

    function back() {
        if ($scope.driverForm.$dirty) {
            Alerts.show({
                title: 'Are you sure?',
                text: 'There are unsaved changes to this driver. Are you sure you want to leave?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, lose changes.',
                cancelButtonText: 'No, return to the driver.',
                closeOnConfirm: true,
                closeOnCancel: true
            },
                result => result && loadDriverListState()
            );
        } else {
            loadDriverListState();
        }
    }

    function loadDriverListState() {
        window.history.back();
    }

    function deleteDriver() {
        var midnightThisMorning = moment(new Date().setHours(0,0,0,0));
        if (!vm.driver.leaveDate || moment(vm.driver.leaveDate, 'DD MMMM YYYY') > midnightThisMorning) {
            Alerts.show('Invalid leave date','Please enter a leave date that is today or in the past before deleting a driver.');
            return;
        }

        var updateLeaveDate = !$scope.driverForm.$pristine;
        DriversService.deleteDriver(vm.driver, updateLeaveDate).then(() => {
            Alerts.show('Success!', 'Driver deleted!', 'success');
            $scope.driverForm.$setPristine(); //in-case any edits had been made before deletion
            back();
        });
    }
    
    function restoreDeletedDriver() {
        vm.driver.deletedFlag = false;
        save();
    }

    function validate() {
        vm.validationErrors.length = 0;
        checkLeaveDate();
    }

    function checkLeaveDate() {
        if (vm.driver.leaveDate && vm.driver.leaveDate <= vm.driver.startDate) {
            vm.validationErrors.push('Leave date must be greater than start date.');
        }
    }

    function backupDriverChanged() {
        if (vm.driver.backupDriver) {
            tmpContractedHours = vm.driver.contractedHours;
            vm.driver.contractedHours = 0;
        } else {
            vm.driver.contractedHours = tmpContractedHours;
        }
    }

    function getDays() {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days;
    }

    function getDriver() {
        vm.driver = {
            id: 0,
            contractedHours: 37.5,
            preferences: []
        };

        const id = $stateParams.id;

        if (id && id !== 'new') {
            DriversService.getDriver(id).then(data => {
                vm.driver = data;
                if (vm.driver.startDate) {
                    vm.driver.startDate = data.startDate && new Date(data.startDate);
                }
                if (vm.driver.leaveDate) {
                    vm.driver.leaveDate = data.leaveDate && new Date(data.leaveDate);
                }
                angular.element(document).ready(() => {
                    //we need the timeout for $setPristine to work.  My guess is this is something to do with datepicker initialisation.
                    $timeout($scope.driverForm.$setPristine);
                });
            });
        }
    }

    function addPreference(pref) {
        if (pref) {
            const preference = {
                day: pref.day,
                start: formatTime(pref.start),
                end: formatTime(pref.end),
                allDay: pref.allDay,
                week1: pref.week1,
                week2: pref.week2,
                week3: pref.week3,
                week4: pref.week4
            };

            if (isValidPreference(preference)) {
                if (checkDuplicates(preference)) {
                     Alerts.show('Error!', 'This preference is a duplicate of an existing preference!', 'error');
                } else {
                    vm.driver.preferences.push(preference);
                    for (var member in pref) delete pref[member];   
                }

            }
        }
    }

    function isValidPreference(preference) {
        if (!preference) return false;
        if (!preference.day) return false;
        if (!preference.allDay && !isValidTimeSpan(preference.start, preference.end)) return false;
        if (!preference.week1 && !preference.week2 && !preference.week3 && !preference.week4) return false;
        return true;
    }
    
    function setDefaultPreference(preference)
    {
        if (angular.isUndefined(preference.day)) preference.day = '';
        if (angular.isUndefined(preference.allDay)) preference.allDay = false;
        if (angular.isUndefined(preference.week1)) preference.week1 = false;
        if (angular.isUndefined(preference.week2)) preference.week2 = false;
        if (angular.isUndefined(preference.week3)) preference.week3 = false;
        if (angular.isUndefined(preference.week4)) preference.week4 = false;
        if (preference.allDay){
            preference.start = 0;
            preference.end = 0;    
        }
    }
    
    function checkDuplicates(preference) {
        setDefaultPreference(preference);
        for (var key in vm.driver.preferences) {
            var pref = vm.driver.preferences[key];
            if (pref.day == preference.day &&
                pref.start == preference.start &&
                pref.end == preference.end &&
                pref.allDay == preference.allDay &&
              ( pref.week1 == preference.week1 ||
                pref.week2 == preference.week2 ||
                pref.week3 == preference.week3 ||
                pref.week4 == preference.week4 )
            ) return true;
        }
        return false;
    }
    
    function isValidTimeSpan(start, end) {
        if (isNaN(start) || isNaN(end)) return false;
        if (start >= end) return false;
        return true;
    }

    function deletePreference(index) {
        if (index != -1) {
            vm.driver.preferences.splice(index, 1);
        }
    }

    function formatTime(date) {
        const time = new Date(date);
        const hours = ('0' + time.getHours()).slice(-2);
        const minutes = ('0' + time.getMinutes()).slice(-2);
        return hours + '' + minutes;
    }
}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('drivers.edit', {
        controller: controller,
        controllerAs: 'vm',
        params: {
            id: 'new'
        },
        parent: 'authorised',
        template: template,
        url: '/drivers/edit/{id}'
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/authorised/driveredit/index.js